import Actions from '../../odata/actions';

const actions = new Actions('customerUser', 'customerUsers');

export default actions;
